/* eslint-disable react/jsx-no-target-blank */
import React from 'react'
// import { SidebarMenuItemWithSub } from './SidebarMenuItemWithSub'
import { SidebarMenuItem } from './SidebarMenuItem'
import { useAuthStore } from 'Store/Auth'
import { shallow } from 'zustand/shallow'
import RolePermissionConfigs from 'Configuration/RolePermission'

const SidebarMenuMain = () => {
  const roleId = useAuthStore(state => state.profile?.roleId ?? 0, shallow)
  const isDemo = process.env.REACT_APP_PACO_VERSION === 'DEMO'

  const checkPermission = (permissionConfig: number[], roleId: number) => {
    return permissionConfig.includes(roleId)
  }

  return (
    <>
      {RolePermissionConfigs.dashboard_overview.includes(roleId) && (
        <SidebarMenuItem
          to='/dashboard/summary'
          icon='/media/icons/duotune/general/gen001.svg'
          title={'Dashboard'}
          fontIcon='bi-app-indicator'
        />
      )}
      <SidebarMenuItem
        to='/home'
        icon='/media/icons/duotune/general/gen001.svg'
        title={'หน้าหลัก'}
        fontIcon='bi-app-indicator'
      />

      {!isDemo && (
        <>
          {checkPermission(
            [
              ...RolePermissionConfigs.dashboard_overview,
              ...RolePermissionConfigs.dashboard_operation,
            ],
            roleId
          ) && (
            <div className='menu-item'>
              <div className='menu-content pt-8 pb-2'>
                <span className='menu-section text-muted text-uppercase fs-8 ls-1'>ภาพรวม</span>
              </div>
            </div>
          )}

          {RolePermissionConfigs.dashboard_overview.includes(roleId) && (
            <SidebarMenuItem
              to='/dashboard/overview'
              icon='/media/icons/duotune/graphs/gra001.svg'
              title='ผู้บริหาร'
              fontIcon='bi-layers'
            />
          )}

          {RolePermissionConfigs.dashboard_operation.includes(roleId) && (
            <SidebarMenuItem
              to='/dashboard/operation'
              icon='/media/icons/duotune/layouts/lay001.svg'
              title='ปฎิบัติการ'
              fontIcon='bi-layers'
            />
          )}
        </>
      )}

      {checkPermission(
        [
          ...RolePermissionConfigs.project,
          ...RolePermissionConfigs.sale_order,
          ...RolePermissionConfigs.survey,
        ],
        roleId
      ) && (
        <div className='menu-item'>
          <div className='menu-content pt-8 pb-2'>
            <span className='menu-section text-muted text-uppercase fs-8 ls-1'>
              การจัดการโครงการ
            </span>
          </div>
        </div>
      )}

      {!isDemo && RolePermissionConfigs.project.includes(roleId) && (
        <SidebarMenuItem
          to='/project'
          icon='/media/icons/duotune/general/gen005.svg'
          title='โครงการทั้งหมด'
          fontIcon='bi-layers'
        />
      )}

      {RolePermissionConfigs.survey.includes(roleId) && (
        <SidebarMenuItem
          to='/survey'
          icon='/media/icons/duotune/files/fil024.svg'
          title='การสำรวจ (Survey)'
          fontIcon='bi-layers'
        />
      )}

      {RolePermissionConfigs.sale_order.includes(roleId) && (
        <SidebarMenuItem
          to='/sale-order'
          icon='/media/icons/duotune/finance/fin010.svg'
          title='ใบสั่งขาย (SO)'
          fontIcon='bi-layers'
        />
      )}

      {checkPermission([...RolePermissionConfigs.machine], roleId) && (
        <div className='menu-item'>
          <div className='menu-content pt-8 pb-2'>
            <span className='menu-section text-muted text-uppercase fs-8 ls-1'>ข้อมูลตั้งต้น</span>
          </div>
        </div>
      )}

      {RolePermissionConfigs.machine.includes(roleId) && (
        <SidebarMenuItem
          to='/machine'
          icon='/media/icons/duotune/technology/teh005.svg'
          title='เครื่องจักร'
          fontIcon='bi-layers'
        />
      )}

      {RolePermissionConfigs.machine.includes(roleId) && (
        <SidebarMenuItem
          to='/pile'
          icon='/media/icons/duotune/technology/teh010.svg'
          title='เสาเข็ม'
          fontIcon='bi-layers'
        />
      )}

      {!isDemo && (
        <>
          {checkPermission(
            [
              ...RolePermissionConfigs.shipping_request,
              ...RolePermissionConfigs.request,
              ...RolePermissionConfigs.maintenance,
            ],
            roleId
          ) &&
            roleId !== 8 && (
              <div className='menu-item'>
                <div className='menu-content pt-8 pb-2'>
                  <span className='menu-section text-muted text-uppercase fs-8 ls-1'>รายงาน</span>
                </div>
              </div>
            )}

          {RolePermissionConfigs.shipping_request.includes(roleId) &&
            roleId !== 11 &&
            roleId !== 8 && (
              <SidebarMenuItem
                to='/shipping-request'
                icon='/media/icons/duotune/ecommerce/ecm006.svg'
                title='คำขอการขนส่ง'
                fontIcon='bi-layers'
              />
            )}

          {RolePermissionConfigs.maintenance.includes(roleId) && (
            <SidebarMenuItem
              to='/maintenance'
              icon='/media/icons/duotune/coding/cod001.svg'
              title='แจ้งปัญหา'
              fontIcon='bi-layers'
            />
          )}

          {RolePermissionConfigs.request.includes(roleId) && (
            <SidebarMenuItem
              to='/request'
              icon='/media/icons/duotune/files/fil005.svg'
              title='คำร้องขอ'
              fontIcon='bi-layers'
            />
          )}
        </>
      )}

      <div className='mt-5 mb-5' style={{ borderBottom: '1px dashed #393945' }} />

      {RolePermissionConfigs.user.includes(roleId) && (
        <SidebarMenuItem
          to='/users'
          icon='/media/icons/duotune/general/gen049.svg'
          title='จัดการผู้ใช้งาน'
          fontIcon='bi-layers'
        />
      )}

      <SidebarMenuItem
        to='/sign-out'
        icon='/media/icons/duotune/arrows/arr015.svg'
        title='ลงชื่อออก'
        fontIcon='bi-layers'
      />
    </>
  )
}

export { SidebarMenuMain }
